import { defineComponent, onMounted, onUnmounted, ref } from "vue";
export default defineComponent({
    name: "PlayerFullscreen",
    props: {
        containerId: {
            type: String,
            default: "player-main"
        },
        size: {
            type: Number,
            default: 22
        }
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var handleClick = function handleClick() {
            var container = document.querySelector("#".concat(props.containerId));
            if (!container) return;
            container.requestFullscreen();
        };
        var exitFullscreen = function exitFullscreen() {
            document.exitFullscreen();
        };
        var handleFullscreenchange = function handleFullscreenchange(e) {
            isFullscreen.value = e.target === document.fullscreenElement;
            emit("fullscreenchange", isFullscreen.value);
        };
        var isFullscreen = ref(false);
        onMounted(function() {
            document.addEventListener("fullscreenchange", handleFullscreenchange);
        });
        onUnmounted(function() {
            document.removeEventListener("fullscreenchange", handleFullscreenchange);
        });
        return {
            handleClick: handleClick,
            isFullscreen: isFullscreen,
            exitFullscreen: exitFullscreen
        };
    }
});
